<form #nomeArquivoForm="ngForm">
    <app-custom-modal #modal [title]="'Definir nome do rascunho'" (onCloseClick)="modal.close()"
        (onSaveClick)="save()" [saveLabel]="'Salvar'"
        hideCancel [saveDisabled]="nomeArquivoForm.invalid">
        <div class="container">
            <div class="mb-4">
                <label for="nome" class="form-label">Nome</label>
                <input type="text" class="form-control" name="nome" maxlength="150" [(ngModel)]="nomeArquivo"
                    #nomeModel="ngModel" #nomeEl id="nome" required placeholder="Digite aqui" />
                <abp-validation-summary [control]="nomeModel" [controlEl]="nomeEl"></abp-validation-summary>
            </div>
        </div>
    </app-custom-modal>
</form>